import React from "react";
function TableRow({category, sumDone, percentDone, sumInProgress, percentInProgres, sumTodo, percentTodo, sumAll}){
    return (
        <tr>
            <td>{category}</td>
            <td>{sumDone}</td>
            <td>{percentDone}%</td>
            <td>{sumInProgress}</td>
            <td>{percentInProgres}%</td>
            <td>{sumTodo}</td>
            <td>{percentTodo}%</td>
            <td>{sumAll}</td>
        </tr>
    );
}

function TablePengaduan() {

    return (
        <div>
            <div className="container-publikasi-pengaduan publikasi-pengaduan-table">
                <div className="section-title text-center mb-4">
                    <h2 className="text-header">Publikasi Penanganan Pengaduan</h2>
                </div>
                <h4 className="mb-4 self-center" style={{color: '#272727'}}>Periode Januari - November 2025</h4>
                <div className="table-wrapper">
                    <table className="custom-table">
                        <thead>
                        <tr>
                            <th rowSpan="2">Jenis Transaksi Keuangan</th>
                            <th colSpan="2">Selesai</th>
                            <th colSpan="2">Dalam Proses</th>
                            <th colSpan="2">Tidak Selesai</th>
                            <th rowSpan="2">Jumlah Pengaduan</th>
                        </tr>
                        <tr>
                            <th>Jumlah</th>
                            <th>Persentase</th>
                            <th>Jumlah</th>
                            <th>Persentase</th>
                            <th>Jumlah</th>
                            <th>Persentase</th>
                        </tr>
                        </thead>

                        <tbody>
                        <TableRow
                            category='Layanan Pendanaan bersama Berbasis Teknologi'
                            sumDone='1.688'
                            percentDone='100'
                            sumInProgress='0'
                            percentInProgres='0'
                            sumTodo='0'
                            percentTodo='0'
                            sumAll='1.688'
                        />
                        </tbody>

                        <tfoot>
                        <TableRow
                            category='TOTAL'
                            sumDone='1.688'
                            percentDone='100'
                            sumInProgress='0'
                            percentInProgres='0'
                            sumTodo='0'
                            percentTodo='0'
                            sumAll='1.688'
                        />
                        </tfoot>
                    </table>
                </div>
                <br/><br/>
                <div className="table-wrapper">
                    <table className="custom-table">
                        <thead>
                        <tr>
                            <th rowSpan="2">Kategori Permasalahan</th>
                            <th colSpan="2">Selesai</th>
                            <th colSpan="2">Dalam Proses</th>
                            <th colSpan="2">Tidak Selesai</th>
                            <th rowSpan="2">Jumlah Pengaduan</th>
                        </tr>
                        <tr>
                            <th>Jumlah</th>
                            <th>Persentase</th>
                            <th>Jumlah</th>
                            <th>Persentase</th>
                            <th>Jumlah</th>
                            <th>Persentase</th>
                        </tr>
                        </thead>

                        <tbody>
                        <TableRow
                            category='Penghapusan Akun/Diskon'
                            sumDone='1.433'
                            percentDone='100'
                            sumInProgress='0'
                            percentInProgres='0'
                            sumTodo='0'
                            percentTodo='0'
                            sumAll='1.433'
                        />
                        <TableRow
                            category='Informasi Pembayaran'
                            sumDone='17'
                            percentDone='100'
                            sumInProgress='0'
                            percentInProgres='0'
                            sumTodo='0'
                            percentTodo='0'
                            sumAll='17'
                        />
                        <TableRow
                            category='Informasi Pengajuan'
                            sumDone='128'
                            percentDone='100'
                            sumInProgress='0'
                            percentInProgres='0'
                            sumTodo='0'
                            percentTodo='0'
                            sumAll='128'
                        />
                        <TableRow
                            category='Informasi Tagihan'
                            sumDone='25'
                            percentDone='100'
                            sumInProgress='0'
                            percentInProgres='0'
                            sumTodo='0'
                            percentTodo='0'
                            sumAll='25'
                        />
                        <TableRow
                            category='Pengkinian Data'
                            sumDone='35'
                            percentDone='100'
                            sumInProgress='0'
                            percentInProgres='0'
                            sumTodo='0'
                            percentTodo='0'
                            sumAll='35'
                        />
                        <TableRow
                            category='Permintaan Kode OTP'
                            sumDone='1'
                            percentDone='100'
                            sumInProgress='0'
                            percentInProgres='0'
                            sumTodo='0'
                            percentTodo='0'
                            sumAll='1'
                        />
                        <TableRow
                            category='Sistem/Aplikasi'
                            sumDone='49'
                            percentDone='100'
                            sumInProgress='0'
                            percentInProgres='0'
                            sumTodo='0'
                            percentTodo='0'
                            sumAll='49'
                        />
                        </tbody>

                        <tfoot>
                        <TableRow
                            category='TOTAL'
                            sumDone='1.688'
                            percentDone='100'
                            sumInProgress='0'
                            percentInProgres='0'
                            sumTodo='0'
                            percentTodo='0'
                            sumAll='1.688'
                        />
                        </tfoot>
                    </table>
                </div>
            </div>
            <div className="container-publikasi-pengaduan publikasi-pengaduan-table">
                <h4 className="mb-4 self-center" style={{color: '#272727'}}>Periode Januari - November 2024</h4>
                <div className="table-wrapper">
                    <table className="custom-table">
                        <thead>
                        <tr>
                            <th rowSpan="2">Jenis Transaksi Keuangan</th>
                            <th colSpan="2">Selesai</th>
                            <th colSpan="2">Dalam Proses</th>
                            <th colSpan="2">Tidak Selesai</th>
                            <th rowSpan="2">Jumlah Pengaduan</th>
                        </tr>
                        <tr>
                            <th>Jumlah</th>
                            <th>Persentase</th>
                            <th>Jumlah</th>
                            <th>Persentase</th>
                            <th>Jumlah</th>
                            <th>Persentase</th>
                        </tr>
                        </thead>

                        <tbody>
                        <TableRow
                            category='Layanan Pendanaan bersama Berbasis Teknologi'
                            sumDone='2.780'
                            percentDone='100'
                            sumInProgress='0'
                            percentInProgres='0'
                            sumTodo='0'
                            percentTodo='0'
                            sumAll='2.780'
                        />
                        </tbody>

                        <tfoot>
                        <TableRow
                            category='TOTAL'
                            sumDone='2.780'
                            percentDone='100'
                            sumInProgress='0'
                            percentInProgres='0'
                            sumTodo='0'
                            percentTodo='0'
                            sumAll='2.780'
                        />
                        </tfoot>
                    </table>
                </div>
                <br/><br/>
                <div className="table-wrapper">
                    <table className="custom-table">
                        <thead>
                        <tr>
                            <th rowSpan="2">Kategori Permasalahan</th>
                            <th colSpan="2">Selesai</th>
                            <th colSpan="2">Dalam Proses</th>
                            <th colSpan="2">Tidak Selesai</th>
                            <th rowSpan="2">Jumlah Pengaduan</th>
                        </tr>
                        <tr>
                            <th>Jumlah</th>
                            <th>Persentase</th>
                            <th>Jumlah</th>
                            <th>Persentase</th>
                            <th>Jumlah</th>
                            <th>Persentase</th>
                        </tr>
                        </thead>

                        <tbody>
                        <TableRow
                            category='Penghapusan Akun/Diskon'
                            sumDone='1.874'
                            percentDone='100'
                            sumInProgress='0'
                            percentInProgres='0'
                            sumTodo='0'
                            percentTodo='0'
                            sumAll='1.874'
                        />
                        <TableRow
                            category='Informasi Pembayaran'
                            sumDone='81'
                            percentDone='100'
                            sumInProgress='0'
                            percentInProgres='0'
                            sumTodo='0'
                            percentTodo='0'
                            sumAll='81'
                        />
                        <TableRow
                            category='Informasi Pengajuan'
                            sumDone='525'
                            percentDone='100'
                            sumInProgress='0'
                            percentInProgres='0'
                            sumTodo='0'
                            percentTodo='0'
                            sumAll='525'
                        />
                        <TableRow
                            category='Informasi Tagihan'
                            sumDone='8'
                            percentDone='100'
                            sumInProgress='0'
                            percentInProgres='0'
                            sumTodo='0'
                            percentTodo='0'
                            sumAll='8'
                        />
                        <TableRow
                            category='Informasi Tenor'
                            sumDone='1'
                            percentDone='100'
                            sumInProgress='0'
                            percentInProgres='0'
                            sumTodo='0'
                            percentTodo='0'
                            sumAll='1'
                        />
                        <TableRow
                            category='Kendala Pencairan'
                            sumDone='22'
                            percentDone='100'
                            sumInProgress='0'
                            percentInProgres='0'
                            sumTodo='0'
                            percentTodo='0'
                            sumAll='22'
                        />
                        <TableRow
                            category='Pembatalan Pinjaman'
                            sumDone='2'
                            percentDone='100'
                            sumInProgress='0'
                            percentInProgres='0'
                            sumTodo='0'
                            percentTodo='0'
                            sumAll='2'
                        />
                        <TableRow
                            category='Penagihan'
                            sumDone='2'
                            percentDone='100'
                            sumInProgress='0'
                            percentInProgres='0'
                            sumTodo='0'
                            percentTodo='0'
                            sumAll='2'
                        />
                        <TableRow
                            category='Pengkinian Data'
                            sumDone='94'
                            percentDone='100'
                            sumInProgress='0'
                            percentInProgres='0'
                            sumTodo='0'
                            percentTodo='0'
                            sumAll='94'
                        />
                        <TableRow
                            category='Permintaan Kode OTP'
                            sumDone='1'
                            percentDone='100'
                            sumInProgress='0'
                            percentInProgres='0'
                            sumTodo='0'
                            percentTodo='0'
                            sumAll='1'
                        />
                        <TableRow
                            category='Sistem/Aplikasi'
                            sumDone='170'
                            percentDone='100'
                            sumInProgress='0'
                            percentInProgres='0'
                            sumTodo='0'
                            percentTodo='0'
                            sumAll='170'
                        />
                        </tbody>

                        <tfoot>
                        <TableRow
                            category='TOTAL'
                            sumDone='2.780'
                            percentDone='100'
                            sumInProgress='0'
                            percentInProgres='0'
                            sumTodo='0'
                            percentTodo='0'
                            sumAll='2.780'
                        />
                        </tfoot>
                    </table>
                </div>
            </div>
        </div>
    );
}

export default TablePengaduan;